import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import useInputObject from "../../hooks/useInputObject";
import { getVar, updateVar } from "../../http/api/VarAPI";
import VarInfo from "./VarInfo";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規変数更新ページ
const VarEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { varDiv, varCd } = location.state;
  const varInfo = useInputObject({});

  // 変数取得
  useEffect(() => {
    if (varDiv != null && varCd != null) {
      GetVarItem();
    }
  }, [varDiv, varCd]);

  async function GetVarItem() {
    let response = await getVar({ varDiv, varCd });
    varInfo.setValue(response.listVarInfo[0]);
  }

  const handleClickReturn = (event) => {
    navigate(-1);
  };
  // 更新ボタンをクリックするイベント
  async function handleClickUpdate() {
    try {
      let updateItem = varInfo.Value;
      updateItem.updatedId = 1; //TODO JWTを追加した後削除
      let response = await updateVar(updateItem);
      alert("変数を編集しました。");
      navigate("/company/var", {
        state: { varDiv },
      });
    } catch {
      alert("変数を編集できませんでした。");
    }
  }

  return (
    <CompanyTitledPage title="変数編集">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              変数情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={handleClickUpdate}>
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 変数情報 */}
      <VarInfo
        varInfo={varInfo}
        isUpdateMode={true}
      />
    </CompanyTitledPage>
  );
};
export default VarEditPage;
